import { Component } from "react"
export default class Menu extends Component {
    render() {
        return (
            <div>
            </div>
        )
    }
}
